import{defineProperty as r}from"../../../../_virtual/_rollupPluginBabelHelpers.js";var e,l=5;!function(r){r.MEDIUM="medium",r.LARGE="large"}(e||(e={}));var a=r(r({},e.MEDIUM,40),e.LARGE,48);export{a as RowHeights,e as RowSizes,l as SKELETON_ROWS_AMOUNT};
//# sourceMappingURL=TableConsts.js.map
